import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import style from './styles/style.module.css';

export default class ButtonTemplate extends PureComponent {
    render() {
        const { label } = this.props;
        const labelClass = `${ this.props.labelClass } ${ style.label }`.trim();
        const effectClass = `${ this.props.effectClass } ${ style.effect }`.trim();
        const backgroundClass = `${ this.props.backgroundClass } ${ style.backgroundColor }`.trim();
        return (
            <button className={ `${ this.props.className } ${ style.buttonTemplate }` }
            style={ this.props.style }
            disabled={ this.props.disabled }
            alt={ this.props.alt }
            type={ this.props.type }
            onClick={ this.props.onClick }
            data-medium={ this.props.medium }
            data-reverse={ this.props.reverse }
            data-full-width={ this.props.fullWidth }
            data-hook={ this.props[ 'data-hook' ] } >
                { this.props.showEffect ?
                    <div className={ effectClass }>
                        <div className={ backgroundClass }></div>
                        <span className={ labelClass } style={ this.props.labelStyle }>{ label }</span>
                    </div>
                    :
                    <span className={ labelClass } style={ this.props.labelStyle }>{ label }</span>
                }
            </button>
        );
    }
}
ButtonTemplate.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    label: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.object,
    ] ).isRequired,
};
ButtonTemplate.defaultProps = {
    label: '',
    className: '',
    labelClass: '',
    effectClass: '',
    backgroundClass: '',
    onClick: () => {},
    type: 'button',
    showEffect: true,
};
